import { useEffect, useState } from 'react'

import {
  formatCogoBasketLabel,
  getCogoBasketStatus,
  subscribeCogoBasketStatus,
  type CogoBasketStatus,
} from './cogoBasketWorker'

/** Live background-basket status from the global worker. */
export function useCogoBasketStatus() {
  const [status, setStatus] = useState<CogoBasketStatus>(getCogoBasketStatus)

  useEffect(() => subscribeCogoBasketStatus(setStatus), [])

  return {
    status,
    label: formatCogoBasketLabel(status),
    active: status.enabled && status.phase === 'syncing',
  }
}
